import script from "./AltaPayPaymentMethods.vue?vue&type=script&lang=ts&setup=true"
export * from "./AltaPayPaymentMethods.vue?vue&type=script&lang=ts&setup=true"

import "./AltaPayPaymentMethods.vue?vue&type=style&index=0&id=d3f49772&lang=less&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3f49772"]])

export default __exports__